export enum Environment {
  LOCAL,
  DEVELOPMENT,
  TEST,
  ACCEPTANCE,
  PRODUCTION,
}
